import React from "react";

const SvgAbout = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M8.41797 6.91602H9.91797V5.41602H8.41797M9.16797 15.166C5.86047 15.166 3.16797 12.4735 3.16797 9.16602C3.16797 5.85852 5.86047 3.16602 9.16797 3.16602C12.4755 3.16602 15.168 5.85852 15.168 9.16602C15.168 12.4735 12.4755 15.166 9.16797 15.166ZM9.16797 1.66602C8.18305 1.66602 7.20778 1.86001 6.29784 2.23692C5.3879 2.61383 4.56111 3.16628 3.86467 3.86271C2.45815 5.26924 1.66797 7.17689 1.66797 9.16602C1.66797 11.1551 2.45815 13.0628 3.86467 14.4693C4.56111 15.1658 5.3879 15.7182 6.29784 16.0951C7.20778 16.472 8.18305 16.666 9.16797 16.666C11.1571 16.666 13.0647 15.8758 14.4713 14.4693C15.8778 13.0628 16.668 11.1551 16.668 9.16602C16.668 8.1811 16.474 7.20583 16.0971 6.29589C15.7202 5.38595 15.1677 4.55915 14.4713 3.86271C13.7748 3.16628 12.948 2.61383 12.0381 2.23692C11.1282 1.86001 10.1529 1.66602 9.16797 1.66602ZM8.41797 12.916H9.91797V8.41602H8.41797V12.916Z"
      fill="#0C0324"
    />
  </svg>
);

export default SvgAbout;
